module.exports = __webpack_public_path__ + "img/categorie-cave-famille-boutrais-small.d3d2ba79.jpg";